import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { CustomType } from "PFTypes";
import { useCallback } from "react";

import { getPermittedTypes, loadForSections, PermissionObject } from "./custom_type";

export const useCustomTypes = () => {
  const {
    data: { custom_types: customTypes }
  } = useMyAccountInfo();

  const getCustomTypeByName = useCallback(
    (name: CustomType["name"]) => (customTypes || []).find((customType) => name === customType.name),
    [customTypes]
  );

  const getCustomTypeById = useCallback(
    (id: CustomType["id"]) => (customTypes || []).find((customType) => id === customType.id),
    [customTypes]
  );

  return {
    customTypes,
    loadForSections: (sections: string | string[]) => loadForSections(sections, customTypes),
    getPermittedTypes: (permitionsObject: PermissionObject) =>
      getPermittedTypes(customTypes, permitionsObject),
    getCustomTypeByName,
    getCustomTypeById
  };
};
